import { Chat } from "pages/Main/Components/Chat";
import styles from "./index.module.css";
import { useContext, useEffect, useState } from "react";
import { readChatByAdmin, startSupportChat } from "helpers/backend_helper";
import { useRequest } from "ahooks";
import { AdminContext, Chats, initialMessages } from "context/adminContext";
import { NotificationContext } from "context/notificationContext";
import { SocketContext } from "context/socketContext";
import { useNavigate } from "react-router";
import { PROP_NAME_CHOOSEN_CHAT_ID, PROP_NAME_CHOOSEN_USER_CHAT_ID, PROP_NAME_MAIN_TAB } from "helpers/constants";
import { STATUSES } from "../../../Chats";
import { RevealChatComponent } from "Components/RevealChatComponent";
import { CustomButton } from "Components/CustomButton";
import arrowRight from "assets/svg/ArrowRight.svg";

type Props = {
  idChat: string;
  supportChatStatus: STATUSES;
  className?: string;
  avatar?: string;
  userId: string;
  unreadMessages: number;
  updateStatusToTaken: () => void;
  size?: number;
};

const mainTabOfUserChatStatus = {
  WAIT: 0,
  IN_PROGRESS: 1,
  FINISHED: 2,
};
export const UserChat = ({
  idChat,
  className,
  userId,
  supportChatStatus,
  unreadMessages,
  updateStatusToTaken,
  size,
}: Props) => {
  const [revealedChat, setRevealedChat] = useState<boolean>(false);
  const { openNotificationWithIcon } = useContext(NotificationContext);
  const { joinChatAdmin, sendMessageSupport, currentChatJoinedID, leaveChatAdmin } = useContext(SocketContext);
  const navigator = useNavigate();
  const {
    localCountry,
    getChatHistory,
    getHistoryLoading,
    chats,
    hasMore: hasMoreSupport,
    setChats,
    chatMetaRef,
  } = useContext(AdminContext);
  const { loading, runAsync: startSession } = useRequest(() => startSupportChat(localCountry?.iso, idChat), {
    ready: !!idChat,
    manual: true,
    onError: (error: any) => {
      openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
    },
    onSuccess: () => {
      openNotificationWithIcon("success", "The session has started");
    },
  });

  useEffect(() => {
    getChatHistory({ chatId: idChat, cursor: 0, localCountry: localCountry?.iso });
    joinChatAdmin(idChat);
    currentChatJoinedID.current = idChat;
    return () => {
      leaveChatAdmin(idChat);
      currentChatJoinedID.current = null;
    };
  }, []);

  useEffect(() => {
    return () => {
      setChats({ supportChat: initialMessages, debateChat: initialMessages } as Chats);
    };
  }, [idChat]);

  const { runAsync: readChat } = useRequest(
    (messageId: number) => {
      return readChatByAdmin(idChat, messageId, localCountry?.iso);
    },
    {
      ready: !!idChat,
      refreshDeps: [localCountry?.iso, idChat],
      manual: true,
      onError: (error: any) => {
        openNotificationWithIcon("error", error.response?.data?.message || "something went wrong");
      },
    },
  );

  useState(() => {
    if (!unreadMessages) setRevealedChat(true);
  });

  return (
    <div className={className ? className + " " + styles.container : styles.container} style={{ height: size }}>
      {!revealedChat && unreadMessages ? (
        <RevealChatComponent
          unreadMessages={unreadMessages}
          onReveal={() => {
            setRevealedChat(true);
            if (chatMetaRef?.current?.firstUnreadMessageId) {
              const emptyArrayOfIds = new Array(
                chatMetaRef.current.lastUnreadMessageId - chatMetaRef.current.firstUnreadMessageId + 1,
              ).fill(0);
              const arrayOfIds = emptyArrayOfIds.map((_, i) => chatMetaRef.current.firstUnreadMessageId + i);
              arrayOfIds.forEach((v) => readChat(v));
            }
          }}
        />
      ) : null}
      <CustomButton
        sizeButton="large"
        typeButton="primary"
        onClick={() => {
          navigator(
            `/chats?${
              supportChatStatus ? `&${PROP_NAME_MAIN_TAB}=${mainTabOfUserChatStatus[supportChatStatus]}` : ""
            }&${PROP_NAME_CHOOSEN_USER_CHAT_ID}=${userId}&${PROP_NAME_CHOOSEN_CHAT_ID}=${idChat}`,
          );
        }}
        style={{ width: 160, position: "absolute", right: 30, top: 30, zIndex: 1000 }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <div>Go to chat</div>
          <img src={arrowRight} alt="right" />
        </div>
      </CustomButton>
      <div
        className={styles.chatContainer}
        style={revealedChat ? { filter: "none", backgroundColor: "transparent" } : null}
      >
        <Chat
          data={{ chatData: chats?.supportChat }}
          flags={{
            hasMore: revealedChat ? hasMoreSupport.current : false,
            loading: loading || getHistoryLoading,
            isOnUser: true,
            currentStatus: supportChatStatus,
          }}
          handlers={{
            loadMore: (cursor) => getChatHistory({ chatId: idChat, cursor, localCountry: localCountry?.iso }),
            sendSocketMessage: sendMessageSupport,
            goToUserChat: () => {
              navigator(
                `/chats?${
                  supportChatStatus ? `&${PROP_NAME_MAIN_TAB}=${mainTabOfUserChatStatus[supportChatStatus]}` : ""
                }&${PROP_NAME_CHOOSEN_USER_CHAT_ID}=${userId}&${PROP_NAME_CHOOSEN_CHAT_ID}=${idChat}`,
              );
            },
            onTakeRequest: async () => {
              await startSession();
              updateStatusToTaken();
            },
            onTakeRequestWithoutRequest: () => {
              updateStatusToTaken();
            },
          }}
          ids={{ chatId: idChat, cursor: chats.supportChat.cursor, userId }}
        />
      </div>
    </div>
  );
};
